import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import { Row, Col, Label, FormGroup, Button } from "reactstrap";
import logosm from "../../../../src/assets/images/logo-dark.webp";
import login_bg from "../../../../src/assets/images/memberportal.webp";
import {
  clearResponse,
  getMemberForgotRequest,
} from "../../../redux/frontend/auth/forgot/action";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import { useRef } from "react";
import { __t } from "../../../i18n/translator";
import { useLocation } from "react-router-dom";
function ForgotPassword(props) {
  const InitialValues = {
    email: "",
    hraMemberId:""
  };
  const [loginFormData, setLoginFormData] = useState(InitialValues);
  const validator = useRef(new SimpleReactValidator());
  const navigate = useNavigate("login");
  const location = useLocation();

  useEffect(() => {
    let refresh = false;
    if (location?.pathname == "/forgotPassword") {
      props.clearResponse();
      refresh = true;
    }
    if (refresh) {
      if (props.MemberLoginStatus) {
        navigate("/login");
        setLoginFormData();
      }
    }
  }, [props.MemberLoginStatus]);

  const handleSubmit = async (values) => {
    if (validator.current.allValid()) {
      props.memberForgotReq(values);
    } else {
      validator.current.showMessages();
    }
  };
  return (
    <div className="comtainer">
      <div className="login_box">
        <div className="login_bg_fornt">
          <img alt="login_bg" src={login_bg} />
        </div>
        <div className="login_field_fornt">
          <Row>
            <Formik initialValues={loginFormData} onSubmit={handleSubmit}>
              {({ values }) => (
                <Col className="login-form">
                  <div className="loging-head">
                    <img alt="Logo" src={logosm} />
                    <h2>Reset Password</h2>
                  </div>
                  <Form className="form-horizontal form-login row">
                    <FormGroup className="col-12 sticky_label">
                      <Field
                        id="hraMemberId"
                        name="hraMemberId"
                        className="form-control"
                        placeholder="HRAXXXX"
                        type="hraMemberId"
                      />
                      <Label className="form-label" htmlFor="hraMemberId">
                        Login Name
                        <span className="text-danger required">*</span>
                      </Label>
                      {validator.current.message(
                        __t("validations.auth.hraMemberId"),
                        values.hraMemberId,

                        "required",
                        {
                          messages: {
                            required: __t("validations.auth.hraMemberId"),
                          },
                        }
                      )}
                    </FormGroup>
                    <FormGroup className="col-12 sticky_label">
                      <Field
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email Address"
                        type="Email"
                      />
                      <Label className="form-label" htmlFor="email">
                        Email Address{" "}
                        <span className="text-danger required">*</span>
                      </Label>
                      {validator.current.message(
                        __t("validations.auth.email"),
                        values.email,

                        "required",
                        {
                          messages: {
                            required: __t("validations.auth.email"),
                          },
                        }
                      )}
                    </FormGroup>

                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <Button
                        type="submit"
                        color="primary"
                        block
                        className="w-auto"
                        title="Send Link"
                      >
                        Submit
                      </Button>
                      <Link
                        to="/login"
                        className="pt-3 d-inline-block w-100 text-center"
                        title="back to login"
                      >
                        Back to login
                      </Link>
                    </div>
                  </Form>
                  <div className="policy-links">
                    <Link
                      to="https://www.hraga.com/terms-of-service"
                      className="d-inline-block"
                      target="_blank"
                      title="Terms of Service"
                    >
                      Terms of Service
                    </Link>
                    <Link
                      to="https://www.hraga.com/mbr-app-privacy-policy"
                      className="d-inline-block"
                      target="_blank"
                      title="Privacy Policy"
                    >
                      Privacy Policy
                    </Link>
                  </div>
                </Col>
              )}
            </Formik>
          </Row>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = ({ MemberForgot }) => {
  let MemberLoginStatus =
    MemberForgot?.forgotPassApiResponse &&
    MemberForgot?.forgotPassApiResponse?.status;

  return {
    MemberLoginStatus: MemberLoginStatus,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    clearResponse: (crd) => dispatch(clearResponse(crd)),
    memberForgotReq: (crd) => dispatch(getMemberForgotRequest(crd)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
